<template>
  <div class="field">
    <label :for="id">{{ label }}</label>
    <div class="password">
      <input
        :id="id"
        :value="modelValue"
        :name="name"
        :type="visible ? 'text' : 'password'"
        :autocomplete="autocomplete"
        :aria-invalid="!!error"
        :aria-describedby="error ? `${id}-error` : undefined"
        @input="
          $emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
      /><button
        type="button"
        :aria-label="visible ? 'Hide password' : 'Show password'"
        @click="visible = !visible"
      >
        {{ visible ? "Hide" : "Show" }}
      </button>
    </div>
    <p v-if="error" :id="`${id}-error`" class="error">{{ error }}</p>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
defineProps<{
  id: string;
  name: string;
  label: string;
  modelValue: string;
  autocomplete: string;
  error?: string;
}>();
defineEmits(["update:modelValue"]);
const visible = ref(false);
</script>
<style scoped>
.field {
  margin-bottom: 1rem;
}
.field label {
  display: block;
  font-weight: 650;
  margin-bottom: 0.4rem;
}
.password {
  display: flex;
}
.password input {
  min-width: 0;
  flex: 1;
  border: 1px solid #717b8d;
  border-radius: 0.3rem 0 0 0.3rem;
  padding: 0.75rem;
  min-height: 44px;
}
.password button {
  min-width: 60px;
  min-height: 44px;
  border: 1px solid #717b8d;
  border-left: 0;
  background: #f3f5f7;
  border-radius: 0 0.3rem 0.3rem 0;
}
.password :focus-visible {
  outline: 3px solid #ee7203;
  outline-offset: 2px;
}
.error {
  color: #9d1c13;
  margin: 0.35rem 0 0;
}
</style>
